import { Badge, Button, StrongText, TableCell, TableRow } from '../../../../components/ui'
import { uiClasses } from '../../../shared/uiClasses'
import { PARTNER_COLORS } from './partnerColors'
import type { TestCatalogItem } from './types'

interface TestCatalogRowProps {
  test: TestCatalogItem
  isOrdering: boolean
  isOrdered: boolean
  onOrderTest: (testId: string) => Promise<void>
}

export function TestCatalogRow({ test, isOrdering, isOrdered, onOrderTest }: TestCatalogRowProps) {
  return (
    <TableRow className="tests-catalog-row">
      <TableCell>
        <div className="min-w-0">
          <div className="flex flex-wrap items-center gap-2">
            <StrongText>{test.name}</StrongText>
            {test.popular && (
              <Badge variant="amber">Popular</Badge>
            )}
          </div>
          <p className={`tests-catalog-description mt-1 text-sm/6 ${uiClasses.textSubtle}`} title={test.description}>
            {test.description}
          </p>
        </div>
      </TableCell>

      <TableCell>
        <Badge variant="zinc">{test.category}</Badge>
      </TableCell>

      <TableCell>
        <Badge variant={PARTNER_COLORS[test.partner] ?? 'zinc'}>
          {test.partner}
        </Badge>
      </TableCell>

      <TableCell className="text-right">
        <StrongText as="span" size="base" className="tabular-nums">
          ${test.price}
        </StrongText>
      </TableCell>

      <TableCell className="text-right">
        <Button className="tests-order-btn" onClick={() => void onOrderTest(test.id)} disabled={isOrdering || isOrdered}>
          {isOrdering ? 'Ordering...' : isOrdered ? 'Ordered' : 'Order'}
        </Button>
      </TableCell>
    </TableRow>
  )
}
